window.Products.Clothing.FlowRacerbackTankTop = function() {
};
window.Products.Clothing.FlowRacerbackTankTop.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.FlowRacerbackTankTop.dpi = 150;
window.Products.Clothing.FlowRacerbackTankTop.has_3d = true;
window.Products.Clothing.FlowRacerbackTankTop.id = 108;
window.Products.Clothing.FlowRacerbackTankTop.slug = 'flow-racerback-tank-top';
window.Products.Clothing.FlowRacerbackTankTop.syncColors = true;
window.Products.Clothing.FlowRacerbackTankTop.texturesLoaded = 0;
window.Products.Clothing.FlowRacerbackTankTop.texturesLoading = false;
window.Products.Clothing.FlowRacerbackTankTop.use_glb = true;

window.Products.Clothing.FlowRacerbackTankTop.prototype.outsideObject = 0;
window.Products.Clothing.FlowRacerbackTankTop.prototype.detailsObject = 1;
window.Products.Clothing.FlowRacerbackTankTop.prototype.position = 0.1;

window.Products.Clothing.FlowRacerbackTankTop.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather")){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.FlowRacerbackTankTop.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"athletic_heather": 0xb3afb0,
		"dark_grey_heather": 0x676363,
		"mauve": 0xd08687,
	};

	return new THREE.Color(colors[_name]);
};